import { useMemo } from "react";
import { enrichStAdjustmentsSummary } from "./enrich-st-adjustments-summary";
import { useStAdjustmentsSummary } from "./query";
import { ST_ADJUSTMENTS_ACCESS, type StAdjustmentsAccess } from "./types";
import { useStAdjustmentsPreview } from "./use-st-adjustments-preview";
import { useTechnicianNames } from "./use-technician-names";

interface StAdjustmentsDataInput {
  businessId: string | null;
  runId: string | null;
  access: StAdjustmentsAccess;
  rosterVersionNumber: number | null;
  enabled: boolean;
}

export const useStAdjustmentsData = ({
  businessId,
  runId,
  access,
  rosterVersionNumber,
  enabled,
}: StAdjustmentsDataInput) => {
  const isPreview = access === ST_ADJUSTMENTS_ACCESS.preview;
  const liveEnabled = enabled && access === ST_ADJUSTMENTS_ACCESS.enabled;
  const previewEnabled = enabled && isPreview;
  const live = useStAdjustmentsSummary(businessId, runId, liveEnabled);
  const preview = useStAdjustmentsPreview(businessId, previewEnabled);
  const liveTechnicianNames = useTechnicianNames(
    businessId,
    rosterVersionNumber,
    liveEnabled,
  );
  const source = isPreview ? preview : live;
  const technicianNames = isPreview
    ? preview.technicianNames
    : liveTechnicianNames;
  const data = useMemo(
    () => enrichStAdjustmentsSummary(source.data, technicianNames),
    [source.data, technicianNames],
  );

  return {
    data,
    isLoading: source.isLoading,
    error: source.error,
    isPreview,
  };
};
